<template>
  <v-card-text class="px-0">
    <h2 v-if="partner === 'establishment'" class="font-weight-light">RECARGA CONTA DIGITAL {{ account.fantasy_name }}</h2>
    <h2 v-else class="font-weight-light">RECARGA CONTA DIGITAL {{ partnerName }}</h2>
    <br>
    <img src="@/assets/recharge.png" style="max-width: 150px;">
    <br>
    <br>
    <h2 class="font-weight-light">
      Recarregue sua conta digital e tenha saldo disponível para usar!
    </h2>
    <p>Recarregue seu saldo através de boleto bancário ou antecipando seu crédito disponível</p>
  </v-card-text>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'RechargeHeader',
  created() {
    this.$store.dispatch('account/getAccount');
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      partnerName: 'account/partnerName',
    })
  }
};
</script>
